/**
 * Questo file include i polyfill necessari ad Angular e viene caricato prima dell'applicazione.
 * È possibile aggiungere altri polyfill a questo file.
 *
 * Questo file è suddiviso in due sezioni:
 *   1. Polyfill del browser, applicati prima del caricamento di ZoneJS e ordinati per browser.
 *   2. Importazioni dell'applicazione, caricate dopo ZoneJS ma prima del file principale.
 *
 * La configurazione attuale è destinata ai cosiddetti browser "evergreen", cioè alle versioni più
 * recenti dei browser che si aggiornano automaticamente. Include Safari >= 10, Chrome >= 55
 * (compreso Opera), Edge >= 13 su computer, iOS 10 e Chrome su dispositivi mobili.
 *
 * Per approfondire: https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * POLYFILL DEL BROWSER
 */

/**
 * Per impostazione predefinita, zone.js applica patch a tutti i macroTask e DomEvents possibili.
 * È possibile disabilitare alcune patch di macroTask o DomEvents impostando i flag seguenti.
 * Poiché i flag vanno definiti prima del caricamento di `zone.js` e webpack inserisce le
 * importazioni all'inizio del bundle, occorre creare un file separato in questa directory
 * (ad esempio zone-flags.ts), inserirvi i flag seguenti e importarlo prima di zone.js.
 * import './zone-flags';
 *
 * Qui sono elencati i flag consentiti in zone-flags.ts.
 *
 * I flag seguenti funzionano con tutti i browser.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disabilita la patch di requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disabilita la patch di proprietà come onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disabilita la patch degli eventi specificati
 *
 *  negli strumenti di sviluppo di IE/Edge, zone.js applica una patch anche a addEventListener.
 *  Il flag seguente consente di ignorare la patch di `zone.js` in IE/Edge.
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Angular richiede Zone JS per impostazione predefinita.
 */
import "zone.js"; // Included with Angular CLI.

/***************************************************************************************************
 * IMPORTAZIONI DELL'APPLICAZIONE
 */

/**
 * Pipe per date, valute, numeri decimali e percentuali.
 * Necessari per tutti i browser tranne Chrome, Firefox, Edge, IE11 e Safari 10.
 */
// import 'intl';  // Run `npm install --save intl`.

(window as any).global = window;
